import React from "react";
import { AUDIENCES } from "@/lib/site";
import {
    GraduationCap, BookOpen, Users, Briefcase, School, Sparkles, UserRound, PenTool, Star, UsersRound,
} from "lucide-react";

const ICONS = [
    GraduationCap, // Final year undergrad
    BookOpen,      // Master
    Star,          // PhD
    PenTool,       // Research assistants
    School,        // Lecturers
    Sparkles,      // Early-career researchers
    UserRound,     // Young academics
    UsersRound,    // Supervisors
    Briefcase,     // Professionals
    Users,         // Anyone new
];

export default function Audience() {
    return (
        <section
            id="audience"
            data-testid="audience-section"
            className="py-20 md:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl mb-12">
                    <div className="font-mono-label text-[color:var(--maroon)]">
                        Who Should Attend
                    </div>
                    <h2
                        className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight"
                        style={{ fontWeight: 500 }}
                    >
                        Built for researchers at every starting point.
                    </h2>
                    <div className="hr-gold mt-5" />
                </div>

                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
                    {AUDIENCES.map((label, i) => {
                        const Icon = ICONS[i] || Users;
                        return (
                            <li
                                key={label}
                                data-testid={`audience-item-${i + 1}`}
                                className="group flex flex-col gap-3 rounded-2xl border border-[color:var(--line)] bg-[color:var(--paper-tint)] p-5 hover:border-[color:var(--maroon)] hover:-translate-y-0.5 transition-all"
                            >
                                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white border border-[color:var(--line)] text-[color:var(--maroon)] group-hover:bg-[color:var(--maroon)] group-hover:text-white transition-colors">
                                    <Icon className="h-5 w-5" />
                                </span>
                                <span className="text-[color:var(--navy)] leading-snug font-medium">
                                    {label}
                                </span>
                            </li>
                        );
                    })}
                </ul>

                <div className="mt-10 rounded-2xl bg-[color:var(--beige-soft)] border border-[color:var(--line)] p-6 max-w-4xl text-slate-700 text-sm leading-relaxed">
                    <span className="font-semibold text-[color:var(--navy)]">Note:</span>{" "}
                    The series is suitable for beginners and also useful for researchers who already
                    have data but need clearer direction in analysis, findings and publication.
                </div>
            </div>
        </section>
    );
}
